import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getPartStockReservations = (code) => apiActionCreator({
  'endpoint': `/orders/dealers/emergent?partCode=${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_STOCK_RESERVATIONS_REQUEST,
    {
      'type': ActionTypes.GET_PART_STOCK_RESERVATIONS_SUCCESS,
    },
    [
      ActionTypes.GET_PART_STOCK_RESERVATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
});
